import React, { useState } from "react";
import PropertyCard from "./PropertyCard";

import "./IndustrialProperties.css";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";

// Industrial Properties Data
const industrialProperties = [
  {
    id: 106,
    areaLocation: " Gidc Ankleshwar",
    title: " DEMO  Properties =>Manufacturing Plant",
    location: "MIDC Area, Gidc Ankleshwar",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12",
    type: "For Sale",
    isFeatured: true,
    imageCount: 6,
    listedDate: "2023-11-15",
    viewCount: 2100,
    propertyType: "industrial",
    size: "10,000 sqft",
    amenities: ["Heavy Power", "Loading Dock", "Storage", "Security"]
  },
  
];

export default function IndustrialProperties() {
  const [visibleCount, setVisibleCount] = useState(6); // show 6 initially

  const [viewMode, setViewMode] = useState("grid");
  const [filterType, setFilterType] = useState("all"); // "all", "sale", "rent"
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");

  // ✅ NEW: State for Area Location filter
  const [selectedArea, setSelectedArea] = useState("All");

  // ✅ NEW: Extract unique area locations from industrialProperties data
  const allAreaLocations = ["All", ...new Set(industrialProperties
    .map(property => property.areaLocation?.trim())
    .filter(area => area && area.trim() !== "")
    .map(area => area.trim())
  )];

  // Filter properties - BY DEFAULT ONLY INDUSTRIAL ✅
  const filteredProperties = industrialProperties.filter(property => {
    // ✅ NEW: First apply area location filter (if not 'All')
    if (selectedArea !== "All" && property.areaLocation?.trim() !== selectedArea) {
      return false;
    }

    // ✅ BY DEFAULT: Only industrial properties (already filtered in data)

    // Sale/Rent filter
    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    // Search filter
    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        (property.amenities && property.amenities.some(amenity =>
          amenity.toLowerCase().includes(searchLower)
        ));

      if (!matchesSearch) return false;
    }

    return true;
  });

  // Sort properties
  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);
      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleResetFilters = () => {
    setFilterType('all');
    setSearchTerm('');
    setSelectedArea('All'); // ✅ NEW: Reset area filter too
  };

  return (
    <section className="industrial-section">

      <div className="industrial-header">
        <div className="industrial-header-left">
          <h2 className="industrial-title">Industrial Properties</h2>
          <p className="industrial-subtitle">Find manufacturing plants, warehouses, factories & industrial plots</p>
        </div>

        <div className="industrial-header-right">
          <span className="industrial-count">
            {sortedProperties.length} Industrial Properties
            {selectedArea !== "All" && ` in ${selectedArea}`} {/* ✅ NEW: Show area if filtered */}
          </span>
        </div>
      </div>

      {/* ✅ NEW: Area Location Filter - Add this ABOVE existing filters */}
      <div className="area-location-filter">
        <h3 className="area-filter-title">Filter by Industrial Area Location</h3>
        <div className="area-filter-buttons">
          {allAreaLocations.map(area => (
            <button
              key={area}
              className={`area-filter-btn ${selectedArea === area ? 'area-active' : ''}`}
              onClick={() => setSelectedArea(area)}
              type="button"
            >
              {area === "All" ? "All GIDC Areas" : area}
            </button>
          ))}
        </div>
      </div>

      {/* 🟡 EXISTING: Filters and Controls */}
      <div className="industrial-controls">
        <div className="industrial-filter-buttons">
          {/* Sale/Rent Filters */}
          <button
            className={`industrial-filter-btn ${filterType === 'all' ? 'industrial-active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Industrial
          </button>
          <button
            className={`industrial-filter-btn ${filterType === 'sale' ? 'industrial-active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`industrial-filter-btn ${filterType === 'rent' ? 'industrial-active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          {/* Search Input - NO PROPERTY TYPE FILTER ✅ */}
          <div className="industrial-search-container">
            <FaSearch className="industrial-search-icon" />
            <input
              type="text"
              placeholder="Search industrial properties..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="industrial-search-input"
              aria-label="Search industrial properties"
            />
            {searchTerm && (
              <button
                className="industrial-clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* View Controls */}
        <div className="industrial-view-controls">
          <div className="industrial-sort-dropdown">
            <FaSortAmountDown className="industrial-sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="industrial-sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
            </select>
          </div>

          <div className="industrial-view-toggle">
            <button
              className={`industrial-view-btn ${viewMode === 'grid' ? 'industrial-active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon */}
            </button>
            <button
              className={`industrial-view-btn ${viewMode === 'list' ? 'industrial-active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`industrial-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} />
        ))}

      </div>

      {/* View More Button */}
      {visibleCount < sortedProperties.length && (
        <div className="industrial-view-more-section">
          <button
            className="industrial-view-more-btn"
            onClick={() => setVisibleCount(prev => prev + 6)} // show 6 more each click
          >
            View More Industrial Properties
          </button>
        </div>
      )}


      {/* No Results Message */}
      {sortedProperties.length === 0 && (
        <div className="industrial-no-results">
          <h3>No Industrial Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="industrial-reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}
    </section>
  );
}